

export function decodeAmp(s: string): string {
    let result = s;
    while (result.includes("&amp;")) {
        result = result.replaceAll("&amp;", "&");
    }
    return result;
}